import Api from '../Api';

import { url } from './config';
import { ServiceAbbreviation } from './types';

const api = new Api<ServiceAbbreviation>(url);

export default api;
